import { render, staticRenderFns } from "./BrokerFundmanager.vue?vue&type=template&id=44870b9c&"
import script from "./BrokerFundmanager.vue?vue&type=script&lang=js&"
export * from "./BrokerFundmanager.vue?vue&type=script&lang=js&"
import style0 from "./BrokerFundmanager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports